import { Injectable } from '@angular/core';
import { Request, Headers, Response } from '@angular/http';
import { HttpClient } from '../../../services/http.service';
import { AppConstants } from '../../../app.constants';
import { Observable } from 'rxjs/Rx';
import { LocalStorageService } from 'ng2-webstorage';
@Injectable()
export class SectionService {
    private schoolId: string;
    constructor(private httpClient: HttpClient,
        private appConstants: AppConstants,
        private localStorage: LocalStorageService) {
        this.schoolId = this.localStorage.retrieve('SchoolId');

    }
    public postSection(deptPayload): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + this.appConstants.sectionalgrade;
        return this.httpClient.Post(url, deptPayload)
            .map(this.extractData)
            .catch(this.handleError)
    }

    public getSections(pagenum,searchString): Observable<Response> {

        if (!searchString) {
            var url: string = '' + this.appConstants.baseUrl + this.appConstants.sectionalgrade + '/' + this.localStorage.retrieve('SchoolId') + '?PageSize=' + 10 + '&pageNumber=' + pagenum ;
        }
        else {
            var url: string = '' + this.appConstants.baseUrl + this.appConstants.sectionalgrade + '/' + this.localStorage.retrieve('SchoolId') + '?PageSize=' + 10 + '&pageNumber=' + pagenum + '&searchString='+ searchString;
        }



        // var url: string = '' + this.appConstants.baseUrl + this.appConstants.sectionalgrade + '/' + this.localStorage.retrieve('SchoolId') +'?PageSize=' + 10 + '&pageNumber=' + pagenum;
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError)
    }

    public DeleteSection(SectionalGradeId): Observable<Response> {
        var url: string = '' + this.appConstants.baseUrl + this.appConstants.sectionalgrade + '/' + SectionalGradeId;
        return this.httpClient.Delete(url)
            .map(this.extractData)
            .catch(this.handleError)
    }

    private extractData(res: Response) {
        let body = res.json();
        return body;
    }

    private handleError(error: any) {
        let errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        let err = JSON.parse(error._body);
        return Observable.throw(err);
    }
}


// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/components/manageuser/sections/sections.service.ts